export default __webpack_public_path__ + "static/media/treedbook.81ab4df3.jpg";